import React from 'react';
import type { LucideProps } from 'lucide-react';
import { cn } from '@/lib/utils';
import whatsappLogo from '@/assets/brand/whatsapp-logo.svg';

// The official WhatsApp logo from the Figma file (lucide-react has no brand icons, and the
// react-icons mark is a flat single colour). Shares lucide's props so it can be a Button/Icon icon.

/** WhatsApp logo at icon size, e.g. inside "Quick claim" and "Chat with support" buttons. */
const WhatsAppIcon: React.FC<LucideProps> = ({ size = 18, className }) => (
  <img
    src={whatsappLogo}
    width={size}
    height={size}
    alt=""
    aria-hidden
    draggable={false}
    className={cn('tw-block tw-shrink-0 tw-select-none', className)}
  />
);

/** Larger logo for cards, e.g. the sidebar's "Quick claim on WhatsApp". */
export const WhatsAppLogo: React.FC<LucideProps> = ({ size = 28, ...rest }) => <WhatsAppIcon size={size} {...rest} />;

export default WhatsAppIcon;
